/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Stock_No_PositionInputs */

const vi_product_stock_no_position = /** @type {(inputs: Product_Stock_No_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa gán vị trí`)
};

/**

* @param {Product_Stock_No_PositionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_stock_no_position = /** @type {((inputs?: Product_Stock_No_PositionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Stock_No_PositionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_stock_no_position(inputs)
});